export let AnimatedCounterProps = {
    counterValue: {
        type: Number,
        default: 35,
    },
    durationProp: {
        type: Number,
        default: 2
    }
}